import { fetchMerchant } from "actions/merchant-admin-account-actions";
import { getStore } from "store";

export default function (nextState, replace, callback) {
    const store = getStore();

    const merchantId = nextState.location.query.merchantId;
    if (merchantId) {
        store.dispatch(fetchMerchant(merchantId));

        const checkDataLoaded = () => {
            const merchantState = store.getState().merchantAdminAccount.merchant;

            if (merchantState.payload && merchantState.payload.deactivated) {
                replace({
                    pathname: "/merchant-deactivated",
                });
                callback();
            } else if (merchantState.payload) {
                callback();
            } else {
                setTimeout(checkDataLoaded, 100);
            }
        };

        checkDataLoaded();
    } else {
        callback();
    }
}
